import { createEvent } from 'effector';

export const onResetServicePackages = createEvent<void>('onResetServicePackages');
export const onGetMyAvailablePersonalDoctorServicePackages = createEvent<void>(
  'onGetMyAvailablePersonalDoctorServicePackages'
);

export const onGetMyBuyServicePackages = createEvent<string>('onGetMyBuyServicePackages');
